import { DialogService, GridAction } from '@eforall/dashboard';
import { TopicSpecialist } from '@interfaces';
import { AssignedStaffDialog, AssignedStaffDialogResult, PersonDialog, VolunteerDialog } from '../../../../../../ui/widget';
import { VolunteeringAreaService } from '../../../../volunteering-area.service';

export function getActions(service: VolunteeringAreaService, dialogService: DialogService) {

	const actions: GridAction<TopicSpecialist>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Volunteer Details',
			isEnabled: rows => !!rows.length && !!rows[0] && !!rows[0].volunteerId,
			execute: async rows => {
				if (rows[0] && rows[0].volunteerId) {
					await dialogService.showCustom(VolunteerDialog, { data: { volunteerId: rows[0].volunteerId } }, 900, 900);
					await service.reloadData();
				}
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Person',
			isEnabled: rows => !!rows.length && !!rows[0] && !!rows[0].volunteerPerson?.id,
			execute: async rows => {
				if (rows[0] && rows[0].volunteerPerson?.id) {
					await dialogService.showCustom(PersonDialog, { data: { personId: rows[0].volunteerPerson.id, toEdit: false } }, 800, 800);
				}
			}
		},
		{
			iconClass: 'fa-regular fa-user-gear',
			label: 'Assign Staff Member',
			isEnabled: rows => {
				if (service.canManageVolunteerStaff()) return !!rows.length && !!rows[0] && !!rows[0].volunteerId;
				return false;
			},
			execute: async rows => {
				if (rows[0] && rows[0].volunteerId) {
					const volunteerName = rows[0]?.volunteerPerson?.fullName;
					const staffId = rows[0]?.assignedToStaffId || 0;
					const action = await dialogService.showCustom(AssignedStaffDialog, {
						data: {
							headerText: volunteerName!,
							staffId: staffId
						}
					}, 800, 300);

					const result = action?.callbackResult as AssignedStaffDialogResult | undefined;
					if (result) {
						await service.updateAssignedStaffForVolunteer(rows[0].volunteerId, result.staffId);
						await service.reloadData();
					}
				}
			}
		},
	];

	return actions;
}